var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.btmList.length > 0
    ? _c("div", { staticClass: "lengend", class: _vm.pz }, [
        _c("div", { staticClass: "flex-around topNav" }, [
          _c("div", { staticClass: "box" }, [
            _vm.btmList.length > 0
              ? _c(
                  "div",
                  { staticClass: "flex warn-table" },
                  _vm._l(_vm.btmList, function (it, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "table flex" },
                      [
                        it.pic
                          ? _c("img", {
                              staticClass: "img",
                              attrs: { src: it.pic },
                            })
                          : _vm._e(),
                        it.name === "种植大户" && !it.pic
                          ? _c("span", { staticClass: "point-zzdh-y" })
                          : _vm._e(),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v(_vm._s(it.name)),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }